import { ResumeUploadService } from '@/services/resume-upload-service'
import { RESUME_UPLOAD_CONTENT_TYPE_SET } from '@rh/shared/constants/resume-content-types'

export interface WizardPdf {
  data: ArrayBuffer
  source: 'local-pdf' | 'converted-docx'
}

/**
 * Turns the uploaded document into PDF bytes for pdf.js.
 * - PDFs are read locally and NEVER leave the browser (the upload may be a
 *   real candidate resume).
 * - Word docs reuse the resume rails verbatim: content-addressed upload +
 *   the LibreOffice Lambda conversion, cached server-side under
 *   converted/{hash} — the UI copy discloses the upload.
 */
export async function getWizardPdf(file: File): Promise<WizardPdf> {
  if (file.type === 'application/pdf' || /\.pdf$/i.test(file.name)) {
    return { data: await file.arrayBuffer(), source: 'local-pdf' }
  }
  const isOffice =
    RESUME_UPLOAD_CONTENT_TYPE_SET.has(file.type) ||
    /\.(docx?|odt|rtf)$/i.test(file.name)
  if (!isOffice) {
    throw new Error(
      'That file type isn’t supported — upload a PDF or Word document.'
    )
  }
  const hash = await ResumeUploadService.upload(file)
  const pdf = await ResumeUploadService.downloadPdfByHash(hash)
  return { data: await pdf.arrayBuffer(), source: 'converted-docx' }
}
